export const API_CONSTANTS = {
  MAP_PERMISSION: "/module/map/permission",
  MODULE_LIST: "/module/list",
  FEATURE_LIST: "/permission/list",
  ENABLE_MENUS: "/module/create/bulk",
  PERMISSION_MAP: "/module/superadmin/get/module-permission-map",
};
